import React, { Suspense, lazy, useEffect, useState, useRef } from "react";
import { Box,  } from "@mui/material";
import { DefaultLayout } from "../components/_layout";
import Loader from "../components/_default/Loader";
import siteData from "../_data";

const Title = "Contact Us";
// Lazy load components
const ContactUsSection = lazy(() =>
  import("../components/_pages/ContactUs/index")
);

// Sections configuration
const sections = [
  { id: "contact-us", label: "Contact Us", Component: ContactUsSection },
];

const ContactUs = () => {
  const [visibleSections, setVisibleSections] = useState({});
  const sectionRefs = useRef({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleSections((prev) => ({
              ...prev,
              [entry.target.id]: true,
            }));
            observer.unobserve(entry.target); // Stop observing once it's visible
          }
        });
      },
      { threshold: 0.1 } // Adjust when the component is considered visible (10% here)
    );

    Object.keys(sectionRefs.current).forEach((id) => {
      if (sectionRefs.current[id]) {
        observer.observe(sectionRefs.current[id]);
      }
    });

    return () => observer.disconnect();
  }, []);

  return (
    <DefaultLayout
      title={`${Title} | ${siteData.brand.name}`}
      description="Musa Institute for Academic and Skills Development "
      isFooterHome={false}
    >
      <Box
        style={{
          position: "relative",
          padding: "0px",
          margin: "0px",
          width: "100%",
        }}
      >
        {sections.map(({ id, Component }) => (
          <Box
            key={id}
            id={id}
            ref={(el) => (sectionRefs.current[id] = el)}
            sx={{
              position: "relative",
              minHeight: "50vh",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {visibleSections[id] ? (
              <Suspense fallback={<Loader />}>
                <Component />
              </Suspense>
            ) : (
              <Loader />
            )}
          </Box>
        ))}
      </Box>
    </DefaultLayout>
  );
};

export default ContactUs;
